import React from 'react';
import PageAuthorize from '../../../../security/PageAuthorize';
import ListContainer from '../../../../presentation/ListContainer';
import layout from './layout.json';

class WholesaleBrokerList extends React.Component {
  render(){
    return (
      <PageAuthorize groups={['Administrators','Operations']}>
        <ListContainer
          id="WholesaleBrokerList"
          layout={layout}
          selectedtab={1}
        />
      </PageAuthorize>
    );
  }
}

export default WholesaleBrokerList;



// WEBPACK FOOTER //
// ./src/content/wholesale/brokers/components/WholsaleBrokerList.js